import * as _  from 'lodash';
export class FirebaseKeyHandler {

    static convertMultiple(snapShoorArray:Array<any>) {
        
        let arrayWithKey:Array<any> = [];

        
        _.forEach(snapShoorArray , (snap) => {
            let valueWithKey:any = {};
            valueWithKey = this.covertSingle(snap);
            arrayWithKey.push(valueWithKey);
        });
       
        return arrayWithKey;
    }

    static covertSingle(snap:any) {
        let valueWithKey:any = {};
        try {
        valueWithKey = snap.payload.val();
        valueWithKey.$key = snap.key;
        } catch ($e) {
            
        }
        return valueWithKey;
    }
}